/* "Firmwide" location content gets a globe, actual per-country locations get a poi marker */
const locationBadgeIcon = (value) => value === "firmwide" ? "globe" : "poi";

export default locationBadgeIcon;
